package com.rikonardo.pluginscan.framework.jar

class JarFile(val files: List<JarEntry>)
